// Include phoenix_html to handle method=PUT/DELETE in forms and buttons.
import 'phoenix_html'
import './shared/mobile_menu'
import './shared/language_select'
import './shared/accordion'
import './shared/upload'
import './shared/cookie_consent'
import {setupFitText} from './shared/fittext'
import './shared/reload'
import './shared/open_summary_on_print'

// Establish Phoenix Socket and LiveView configuration.
import { Socket } from 'phoenix'
import { LiveSocket } from 'phoenix_live_view'
import { register } from 'swiper/element/bundle'
import { appsignal } from './shared/appsignal'
import { cartUpdate } from './shared/cart_update'

// auto scale headlines on mobile to fit the screen
setupFitText();

// Appsignal namespace setting
appsignal('public_frontend')

let csrfToken = document
  .querySelector("meta[name='csrf-token']")
  .getAttribute('content')
let liveSocket = new LiveSocket('/live', Socket, {
  params: { _csrf_token: csrfToken }
})

// trigger add item to cart and update cart session
window.addEventListener(
  'phx:update-cart',

  function ({ detail }) {
    cartUpdate(detail)
  }
)

// connect if there are any LiveViews on the page
liveSocket.connect()
register()

// expose liveSocket on window for web console debug logs and latency simulation:
// >> liveSocket.enableDebug()
// >> liveSocket.enableLatencySim(1000)  // enabled for duration of browser session
// >> liveSocket.disableLatencySim()
window.liveSocket = liveSocket
